import * as React from 'react';
import { connect } from 'react-redux';
import { assign } from '../../../../../shared/Assign';
import { Translate } from '../../../../../shared/LanguageService';
import { handleError } from '../../../../../shared/ErrorCatching';
import AddressModalForm from './AddressModalForm';
import { Modal, Button } from 'react-bootstrap';
import notify from '../../../../../shared/feedback/notifications';
import FormInputChangeHandler from '../../../../../shared/form/FormInputChangeHandler';
import IOrderPrivatePackageAddress from '../entities/IOrderPrivatePackageAddress';

export class OrderAddressModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;
    constructor(props: any) {
        super(props);

        this.state = {
            errors: {},
            creating: false,
            orderAddress: {},
            hasOrderAddress: false
        };
        this.setValue = this.setValue.bind(this);
    }

    setValue(newState: any) {
        this.setState({ orderAddress: newState });
    }

    componentDidMount() {
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.props.orderAddress,
            this.setValue
        );
        this.setState({
            orderAddress: this.props.orderAddress,
            hasOrderAddress: true
        });
    }

    render() {
        if (!this.state.hasOrderAddress) return <div></div>;
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('view-order/contact/modal/title/address')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AddressModalForm
                            orderAddress={this.state.orderAddress}
                            onChange={this.formInputChangeHandler.onChange}
                            onCustomChange={this.formInputChangeHandler.handleChange}
                            errors={this.props.errors}
                            isCommercial={this.props.isCommercial}
                            isPackageOrder={this.props.isPackageOrder}
                            availableCommercialObjectTypes={
                                this.props.availableCommercialObjectTypes
                            }
                            availablePrivateObjectTypes={this.props.availablePrivateObjectTypes}
                            availableContactPersons={this.props.availableContactPersons}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('view-order/contact/modal/footer/button/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={() => {
                                this.props.save(this.state.orderAddress);
                            }}
                        >
                            {Translate('view-order/contact/modal/footer/button/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect()(OrderAddressModal);
